module.exports = __webpack_public_path__ + "img/Orange.f1ba69e8.svg";